import { useEffect, useContext, useState } from "react";
import QlikCard from "components/QlikCard";
import QlikObject from "components/QlikObject";
import GlobalContext from "GlobalContext";


export default function SectoralEvaluation({ title , appDisclaimer , pageTitle, ExportChartFootnote, menuItemsStrings, onPageTitle, navbarObjectId, isMobile }) {
  useEffect(() => {
    document.title = `${pageTitle} - ${title}`;
    onPageTitle && onPageTitle(title);
  }, [pageTitle, title, onPageTitle]);

  const { app } = useContext(GlobalContext);

  return (
    <section className="content fillpage">
      <div className="content-header">
        <div className="mobile-page-header">
          <h4 className="mobile-page-title">{title}</h4>
          {navbarObjectId && isMobile && (
            <div className="mobile-page-object">
              <QlikObject
                key={`mobile-${navbarObjectId}`}
                id={navbarObjectId}
                height="30px"
                showLoader={false}
              />
            </div>
          )}
        </div>
      </div>

      <div className="container-fluid page-default strip-text-row fillpage-body">

        <div className="row justify-content-start fillpage-row">

            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-10 col-xl-10 fillpage-col">

              {/* statistics strip — fixed height */}
              <div className="band-fixed">
                <QlikCard
                  id="AhXPpc"
                  height="34px"
                  showHeader={false}
                  showMaximize={false}
                  showExport={false}
                  actionsVisibility="never"
                />
              </div>

              <div className="band band-top">
                <div className="row justify-content-left band-charts h-100">

                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4 d-flex flex-column">
                    {/* bar chart 1 */}
                    <QlikCard
                      id="7b3bfdb1-5963-4c0c-875b-1bdff8271317"//VJJjG
                      height="100%"
                      showHeader={true}
                      showMaximize={false}
                      showExport={true}
                      showPdfExport
                      showImageExport={true}
                      exportImageWidth={1280}
                      exportImageHeight={720}
                      onBeforeExportHandler={async ({ vis, exportType }) => {
                        console.log(vis);
                        if(exportType in { pdf: true, image: true} && vis)
                          await vis.setOptions({ showTitles: true, footnote: `${ExportChartFootnote}` });
                      }}
                      onAfterExportHandler={async ({ vis, exportType }) => {
                        console.log('Export type: ', exportType);
                        if(exportType in { pdf: true, image: true})
                          vis.setOptions({ showTitles: false, footnote:"" });
                      }}
                      exportText = {menuItemsStrings.exportText}
                      exportCompletedText = {menuItemsStrings.exportCompletedText}
                      closeBtnText = {menuItemsStrings.closeBtnText}
                      exportSelectObjectText={menuItemsStrings.exportSelectObjectText}
                      exportNoObjectText={menuItemsStrings.exportNoObjectText}
                    />
                  </div>

                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4 d-flex flex-column">
                    {/* bar chart 2 */}
                    <QlikCard
                      id="AhGxaqF"//PqHwDQ
                      height="100%"
                      showHeader={true}
                      showMaximize={false}
                      showExport={true}
                      showPdfExport
                      showImageExport={true}
                      exportImageWidth={1280}
                      exportImageHeight={720}
                      onBeforeExportHandler={async ({ vis, exportType }) => {
                        console.log(vis);
                        if(exportType in { pdf: true, image: true} && vis)
                          await vis.setOptions({ showTitles: true, footnote: `${ExportChartFootnote}` });
                      }}
                      onAfterExportHandler={async ({ vis, exportType }) => {
                        console.log('Export type: ', exportType);
                        if(exportType in { pdf: true, image: true})
                          vis.setOptions({ showTitles: false, footnote:"" });
                      }}
                      exportText = {menuItemsStrings.exportText}
                      exportCompletedText = {menuItemsStrings.exportCompletedText}
                      closeBtnText = {menuItemsStrings.closeBtnText}
                      exportSelectObjectText={menuItemsStrings.exportSelectObjectText}
                      exportNoObjectText={menuItemsStrings.exportNoObjectText}
                    />
                  </div>

                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4 d-flex flex-column">
                    {/* bar chart 3 */}
                    <QlikCard
                      id="RttHKBR" //QAPrj
                      height="100%"
                      showHeader={true}
                      showMaximize={false}
                      showExport={true}
                      showPdfExport
                      showImageExport={true}
                      exportImageWidth={1280}
                      exportImageHeight={720}
                      onBeforeExportHandler={async ({ vis, exportType }) => {
                        console.log(vis);
                        if(exportType in { pdf: true, image: true} && vis)
                          await vis.setOptions({ showTitles: true, footnote: `${ExportChartFootnote}` });
                      }}
                      onAfterExportHandler={async ({ vis, exportType }) => {
                        console.log('Export type: ', exportType);
                        if(exportType in { pdf: true, image: true})
                          vis.setOptions({ showTitles: false, footnote:"" });
                      }}
                      exportText = {menuItemsStrings.exportText}
                      exportCompletedText = {menuItemsStrings.exportCompletedText}
                      closeBtnText = {menuItemsStrings.closeBtnText}
                      exportSelectObjectText={menuItemsStrings.exportSelectObjectText}
                      exportNoObjectText={menuItemsStrings.exportNoObjectText}
                    />
                  </div>

                </div>
              </div>

              {/* BOTTOM band — table (ratio+floor, shared with right column) */}
              <div className="band band-bottom band-fill">
                <QlikCard
                  id="86cf8712-f9b7-42f0-baf1-24cb2c329554"
                  height="100%"
                  showHeader={true}
                  showMaximize={true}
                  showExport={true}
                  onBeforeExportHandler={async ({  }) => {
                      await app.variable.setStringValue('export_link', '1');
                  }}
                  onAfterExportHandler={async ({  }) => {
                      app.variable.setStringValue('export_link', '0');
                  }}
                  exportText = {menuItemsStrings.exportText}
                  exportCompletedText = {menuItemsStrings.exportCompletedText}
                  closeBtnText = {menuItemsStrings.closeBtnText}
                  exportSelectObjectText={menuItemsStrings.exportSelectObjectText}
                  exportNoObjectText={menuItemsStrings.exportNoObjectText}
                  actionsVisibility="always"
                  copyCells="true"
                  copiedSuccessMessage={menuItemsStrings.copiedSuccessMessage}
                  copiedFailedMessage={menuItemsStrings.copiedFailedMessage}
                />
              </div>

            </div>


            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 remove-header-spacing fillpage-col">

              {/* TOP band — FilterPane + middle filter (mirrors charts band) */}
              <div className="band band-top filter-col">
                {/* FilterPane — static, sticks to top */}
                <div className="band-fixed">
                  <QlikCard
                    id="f7b3a643-3046-4cd0-9f0c-68be06facc34"
                    height="56px"
                    showHeader={false}
                    showMaximize={false}
                    showExport={false}
                    showOverlayer={false}
                  />
                </div>
                {/* Middle filter — fills the rest of the top band */}
                <div className="filter-grow">
                  <QlikCard
                    id="juSQPP"
                    height="100%"
                    showHeader={false}
                    showMaximize={false}
                    showExport={false}
                    showOverlayer={false}
                  />
                </div>
              </div>

              {/* spacer matching the left column's stats strip, so the
                  right column's bands line up with the charts/table bands */}
              <div className="band-spacer" aria-hidden="true" />

              {/* BOTTOM band — selector + columns-selector (mirrors table band) */}
              <div className="band band-bottom filter-col">
                {/* Selector — static, sticks to top of the band */}
                <div className="band-fixed">
                  <QlikObject
                    id="da4d178e-6777-4980-b8a8-f15793a2e0b6"
                    height="var(--selector-h)"
                    showHeader={false}
                    showMaximize={false}
                    showExport={false}
                    showOverlayer={false}
                  />
                </div>
                {/* Columns Selector — fills the rest of the bottom band */}
                <div className="filter-grow">
                  <QlikCard
                    id="6f6b9505-46cc-4fb3-b912-e45570502cbc"
                    height="100%"
                    showHeader={false}
                    showMaximize={false}
                    showExport={false}
                    showOverlayer={false}
                  />
                </div>
              </div>

            </div>

          </div>

          {/* hidden export helper — outside the fill row */}
          <div className="row">
            <div className="col-md-2 col-sm-3 col-2">
              <QlikObject
                id="7c6b068f-f80f-4a9d-a93d-a37b72c74a45"
                height="0px"
                showLoader={false}
              />
            </div>
          </div>

        </div>
    </section>
  );
}